<template>
<div class="flex flex-col flex-grow items-baseline">
    <label class="block mr-24 mb-8 first-letter:uppercase" for="">
        <slot></slot>
    </label>

    <slot name="tip"></slot>

    <div class="p-8 flex flex-wrap flex-grow items-baseline border border-primary-20 rounded w-480">
        <div
            class="w-full flex justify-around"
            :class="languages.length > 0 ? 'border-b-2 border-primary-20 pb-16 mb-16' : ''">
            <div class="">
                <select-dropdown
                    v-model="selectedLanguage"
                    :options="filteredLanguages"
                    :autoTranslate="false"
                />
            </div>
            <div class="">
                <select-dropdown
                    v-model="selectedLvl"
                    :options="availableLvls"
                    :autoTranslate="false"
                />
            </div>
            <div class="mt-4">
                <simple-button
                    small
                    display="success"
                    :disabled="!selectedLanguage || !selectedLvl"
                    @click="addLanguage"
                >
                    <svg-icon type="add" class="max-w-16 max-h-16" />
                </simple-button>
            </div>
        </div>
        <div
            v-for="(language, index) in languages"
            :key="'serv-' + language.id"
            class="w-full flex justify-between mx-auto bg-primary-5 text-center font-semibold rounded-6 mb-8 py-4 px-12">

            <div class="first-letter:uppercase w-1/3">
                {{ $t('vdab.languages.' + language.id) }}
            </div>
            <div class="first-letter:uppercase">
                {{ $t('vdab.language_lvls.' + language.lvl) }}
            </div>
            <div class="pt-2">
                <button class="text-primary-80 hover:text-primary-80 trans-ease" @click="removeLanguage(index)">
                    <svg-icon type="cancel" class="max-w-16 max-h-16" />
                </button>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import Loading from './Loading.vue';
import { normalizeJson, buildDropdownOptions } from '../../../shared/helpers';
import SvgIcon from './SvgIcon.vue';
import Input from '../forms/Input.vue';
import SelectDropdown from '../forms/SelectDropdown.vue';
import SimpleButton from './SimpleButton.vue';

export default {
    components: {
        'loading': Loading,
        'svg-icon': SvgIcon,
        'simple-input': Input,
        'simple-button': SimpleButton,
        'select-dropdown': SelectDropdown,
    },
    props: {
        currentLanguages: {
            default: [],
            validator: value => Array.isArray(value),
        },
    },
    data: function () {
        return {
            languages: [...this.currentLanguages],
            selectedLanguage: null,
            selectedLvl: null,
            availableLanguages: buildDropdownOptions(
                this.$i18n.messages[this.$i18n.locale].vdab.languages,
                '-- ' + this.$t('general.language') + ' --'),
            availableLvls: buildDropdownOptions(
                this.$i18n.messages[this.$i18n.locale].vdab.language_lvls,
                '-- ' + this.$t('general.level') + ' --'),
        }
    },
    computed: {
        filteredLanguages () {
            let languages = this.languages.map(language => language.id);

            //avoid showing languages already selected
            return this.availableLanguages.filter(language => {
                return !languages.includes(language.value);
            });
        }
    },
    methods: {
        addLanguage () {
            this.languages.push({
                id: this.selectedLanguage,
                lvl: this.selectedLvl,
            });

            this.selectedLanguage = null;
        },
        removeLanguage (index) {
            this.languages.splice(index, 1);
        },
    },
    watch: {
        languages (newLanguages, oldLanguages) {
            this.$emit('select', newLanguages);
        },
    },
}
</script>
